import { Component, OnInit } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { filter, pairwise, take } from 'rxjs/operators';
import { UserRoleEnum } from './auth/enums/user-role.enum';
import { UsersFacade } from './core/services/users.facade';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
	constructor(
		private router: Router,
		private usersFacade: UsersFacade
	) {}

	ngOnInit(): void {
		this.router.events
			.pipe(
				filter((event) => event instanceof RoutesRecognized),
				pairwise(),
				take(1)
			)
			.subscribe((events: any[]) => {
				const url: string = events[0].state.url;

				if (
					url.includes('/auth/set-new-password') &&
					this.usersFacade.loggedUser().roleId === UserRoleEnum.VENDOR_DIRECTOR
				) {
					this.router.navigate(['company']);
				}
			});
	}
}
